import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translation from '../translation/translation';
import Tile from '../product/tile';
import { Premium } from './promotion_texts/premium';
import { Value } from './promotion_texts/value';
import { Budget } from './promotion_texts/budget';
import shippingFeesStore from '../../stores/shipping_fees_store';
import HttpRequestStore from '../../stores/http_request_store';
import ShippingFees from '../product/tile/shipping_fees';
import { allowShippingQuoteOnStore } from '../../../_views/shipping_quote/common';
import ProductBatchStocksStore from '../../stores/product_batch_stocks/product_batch_stocks_store';

const {
    store,
} = TYROOLA.globals;

class CatalogPromotions extends Component {

    constructor() {
        super();
        this.state = {
            shippingData: shippingFeesStore.getState(),
            shippingDataLength: shippingFeesStore.getState().length,
            httpRequestStore: HttpRequestStore.getState(),
            productBatchStocksState: ProductBatchStocksStore.getState(),
        };
    }

    componentDidMount() {
        if (allowShippingQuoteOnStore(store)) {
            shippingFeesStore.addListener(() => this._getShippingStore());
            HttpRequestStore.addListener(() => this._getHttpRequestStore());
            ProductBatchStocksStore.addListener(() => this._getProductBatchStocksStore());
        }
    }

    componentWillUnmount() {
        shippingFeesStore.addListener(() => this._getShippingStore());
        HttpRequestStore.addListener(() => this._getHttpRequestStore());
        ProductBatchStocksStore.addListener(() => this._getProductBatchStocksStore());
    }

    _getShippingStore() {
        this.setState({
            shippingData: shippingFeesStore.getState(),
            shippingDataLength: shippingFeesStore.getState().length,
        });
    }

    _getHttpRequestStore() {
        this.setState({
            httpRequestStore: HttpRequestStore.getState(),
        });
    }

    _getProductBatchStocksStore() {
        this.setState({
            productBatchStocksState: ProductBatchStocksStore.getState(),
        });
    }

    render() {
        const {
            promotions,
            staticImagesUrl,
            onNotifyMeClick,
            onOpenFSFClick,
            metroArea,
            showShowDetailsButton,
            onProductClick,
            currencyIsoCode,
            productType,
            onAlternativeProductStockClick,
            buyerAssistUrl,
        } = this.props;
        const { shippingData, shippingDataLength, httpRequestStore, productBatchStocksState } = this.state;
        if (!promotions.length) {
            return null;
        }
        return (
            <div className="catalog-promotions__container">
                <Translation
                    translationKey="catalog-promotions-headline"
                    className="catalog-promotions__headline"
                    tagName="h2"
                />

                <div className="catalog-promotions">
                    <Premium />
                    <Value />
                    <Budget />
                    {promotions.map((promotion, idx) => {
                        // const { buyerAssistUrl } = promotion;
                        return (
                            <div className="catalog-promotions__product catalog-product catalog-product--promoted"
                                key={promotion.sku}>
                                <Tile
                                    index={idx}
                                    data={Object.assign({}, promotion, {
                                        stock: promotion.stock || 0,
                                        priceRrp: promotion.priceRrp || '',
                                        freeShipping: promotion.freeShipping || false,
                                        showFreeFitting: promotion.showFreeFitting || false,
                                        shippingTime: promotion.shippingTime || '',
                                        onNotifyMeClick: () => onNotifyMeClick(promotion.sku),
                                        onOpenFSFClick: () => onOpenFSFClick(promotion.sku),
                                        productType: productType,
                                        staticImagesUrl: staticImagesUrl,
                                        metroArea: metroArea,
                                        showShowDetailsButton: showShowDetailsButton,
                                        fittingPromotion: promotion.fittingPromotion || null,
                                        catalogPromotion: true,
                                        priceDiscount: promotion.priceDiscount,
                                        customerAverageRatings: promotion.customerAverageRatings,
                                    })}
                                    shippingFees={
                                        <ShippingFees
                                            productSku={promotion.sku}
                                            productType={productType}
                                            promotion={promotion.fittingPromotion}
                                            stock={promotion.stock}
                                            shippingData={shippingData}
                                            currencyIsoCode={currencyIsoCode}
                                            staticImagesUrl={staticImagesUrl}
                                        />
                                    }
                                    shippingData={shippingData}
                                    shippingDataHasValue={shippingDataLength > 0}
                                    onProductClick={onProductClick}
                                    currencyIsoCode={currencyIsoCode}
                                    onSeeHowItWorksClick={this.props.onSeeHowItWorksClick}
                                    httpRequestShippingFees={httpRequestStore.shipping_fees}
                                    productBatchStocks={getProductBatchStock(promotion.sku, productBatchStocksState)}
                                    httpRequestProductBatchStocks={httpRequestStore.product_batch_stocks}
                                    onAlternativeProductStockClick={onAlternativeProductStockClick}
                                    buyerAssistUrl={buyerAssistUrl && buyerAssistUrl.replace('{spinach-id}', promotion.sku)}
                                    isRecommended={true}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

function getProductBatchStock(productSku, productBatchStocksState) {
    let stocks = productBatchStocksState.productBatchStocks;
    let alternativeStocks = null;
    stocks.map(item => {
        if (item.id.value !== productSku) return null;

        alternativeStocks = item;
    });

    return alternativeStocks;
}

CatalogPromotions.propTypes = {
    promotions: PropTypes.array.isRequired,
    staticImagesUrl: PropTypes.string.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
    onNotifyMeClick: PropTypes.func.isRequired,
    onOpenFSFClick: PropTypes.func.isRequired,
    metroArea: PropTypes.string,
    showShowDetailsButton: PropTypes.bool,
    onProductClick: PropTypes.func.isRequired,
    onSeeHowItWorksClick: PropTypes.func.isRequired,
    productType: PropTypes.string,
    onAlternativeProductStockClick: PropTypes.func.isRequired,
    buyerAssistUrl: PropTypes.string
};

export { CatalogPromotions };
